/**
 * SPARQ — global theme behavior: sticky header shadow, mobile nav toggle,
 * header search toggle, and any [data-accordion] triggers used by
 * FAQ/comparison sections. Vanilla JS only.
 */
(function () {
  document.documentElement.classList.remove('no-js');

  /* ---------------- Sticky header shadow ---------------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- Header search toggle ---------------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var isHidden = searchPanel.hidden;
      searchPanel.hidden = !isHidden;
      searchToggle.setAttribute('aria-expanded', String(isHidden));
      if (isHidden) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------------- Mobile nav toggle ---------------- */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var isHidden = mobileNav.hidden;
      mobileNav.hidden = !isHidden;
      menuToggle.setAttribute('aria-expanded', String(isHidden));
    });
  }

  /* ---------------- Generic accordion (FAQ, comparison notes, etc.) ----------------
     Structure: [data-accordion-item] > [data-accordion-trigger] + [data-accordion-panel] */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    var item = trigger.closest('[data-accordion-item]');
    if (!item) return;
    var panel = item.querySelector('[data-accordion-panel]');
    var isOpen = item.classList.contains('is-open');

    if (item.hasAttribute('data-accordion-solo')) {
      var group = item.closest('[data-accordion-group]');
      if (group) {
        group.querySelectorAll('[data-accordion-item].is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            var openPanel = openItem.querySelector('[data-accordion-panel]');
            if (openPanel) openPanel.style.maxHeight = null;
            var openTrigger = openItem.querySelector('[data-accordion-trigger]');
            if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }

    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
    if (panel) panel.style.maxHeight = !isOpen ? panel.scrollHeight + 'px' : null;
  });
})();
